import moment from 'moment'
import io from 'socket.io-client'
import Config from '@/config'
import store from '@/vuex/store'
import SystemConnection, { CONNECTION_STATUS } from '@/utils/system/SystemConnection'

let socket = null

export default {
  initialize: (userId) => {
    socket = io(Config.baseUrlSocket, {
      path: '/api/socket.io-client',
      query: {
        type: 'presenter',
        userId,
      },
      transports: ['websocket', 'polling'],
      withCredentials: true,
    })

    // https://ahaslides.atlassian.net/browse/AHA-4956
    // on reconnection, reset the transports option, as the Websocket
    // connection may have failed (caused by proxy, firewall, browser, ...)
    socket.io.on('reconnect_attempt', (attempts) => {
      // show the connection problem popup if failed after retrying 3 times (~ 15 seconds of retrying)
      if (attempts > 3) {
        store.commit('setSocketDisconnected', true)
      }
      store.commit('setHaveTriedToConnectWebsocket', true)
    })

    socket.on('connect', () => {
      store.commit('setSocketDisconnected', false)
      store.commit('setSocketId', socket.id)
      store.commit('setHaveTriedToConnectWebsocket', true)
      store.commit('setWebsocketConnectionError', null)

      SystemConnection.detectSocketConnection(CONNECTION_STATUS.GOOD)
    })

    socket.on('connect_error', (err) => {
      store.commit('setWebsocketConnectionError', err.message)

      SystemConnection.detectSocketConnection(CONNECTION_STATUS.ERROR)
    })

    socket.on('server_timestamp', (payload) => {
      store.commit('setOffsetTime', moment().utc().format('x') - payload)
    })
  },

  subscribe: (channel, callback) => {
    socket.on(channel, (doc) => {
      return callback(doc)
    })
  },

  unSubscribe: (channel) => {
    if (!socket) {
      return
    }
    socket.removeAllListeners(channel)
  },

  getSocketId: () => {
    return socket?.id
  },

  close: () => {
    if (!socket) return
    socket.close()
  },

  getSocket: () => {
    return socket
  },
  on(...props) {
    return socket.on(...props)
  },
  off(...props) {
    return socket.off(...props)
  },
  emit(...props) {
    return socket.emit(...props)
  },
}
